import { render, staticRenderFns } from "./c1ChatModule.vue?vue&type=template&id=3c201fea"
import script from "./c1ChatModule.vue?vue&type=script&lang=js"
export * from "./c1ChatModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports